import React, { useState } from "react";
import {
  Row,
  Col,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
  Button,
  Alert,
  UncontrolledTooltip,
} from "reactstrap";
import { Link } from "react-router-dom";
import classnames from "classnames";

// hooks

// components
import AudioCallModal from "../../../components/AudioCallModal";
import VideoCallModal from "../../../components/VideoCallModal";
import AddPinnedTabModal from "../../../components/AddPinnedTabModal";


// constants
import { STATUS_TYPES } from "../../../constants";
import { useChat } from "../../../context/ChatContext";
import { extractParseName, extractShortName } from "../../../utils";
import { PinTypes } from "../../../types/bookmarks";

interface PinnedAlertProps {
  onOpenPinnedTab: () => void;
}

interface UserHeadProps {
  chatUserDetails: any;
  pinnedTabs: Array<PinTypes>;
  onOpenUserDetails: () => void;
  onDelete: () => void;
  isChannel: boolean;
  onToggleArchive: () => void;
}

interface ProfileImageProps {
  chatUserDetails: any;
  onCloseConversation: () => any;
  onOpenUserDetails: () => any;
  isChannel: boolean;
}

interface MoreProps {
  onOpenAudio: () => void;
  onOpenVideo: () => void;
  onDelete: () => void;
  isArchive: boolean;
  onToggleArchive: () => void;
}

const ProfileImage = ({
  chatUserDetails,
  onCloseConversation,
  onOpenUserDetails,
  isChannel,
}: ProfileImageProps) => {
  // ✅ fallback seguro para dados indefinidos
  const safeUser = chatUserDetails || {};
  const fullName = chatUserDetails
    ? `${chatUserDetails?.basicDetails.firstName}`.trim() || "-"
    : "Desconhecido";

  let { firstName, lastName } = extractParseName(fullName);
  let { shortName } = extractShortName(firstName, lastName);

  const colors = [
    "bg-primary",
    "bg-danger",
    "bg-info",
    "bg-warning",
    "bg-secondary",
    "bg-pink",
    "bg-purple",
  ];
  const [color] = useState(Math.floor(Math.random() * colors.length));
  const { clearSelectedChat } = useChat();

  //chatUserDetails?.basicDetails
  // const isOnline =
  //   safeUser.status && safeUser.status === STATUS_TYPES.ACTIVE;

  // console.log('chatUserDetails.Blocked', chatUserDetails.basicDetails.Blocked)
  // const isOnline = chatUserDetails.basicDetails.Blocked ? STATUS_TYPES.BLOCKED : STATUS_TYPES.ACTIVE;
  const isOnline = chatUserDetails?.basicDetails?.Blocked ?? false;

  const members = Array.isArray(safeUser.members)
    ? safeUser.members.length
    : 0;

  return (
    <div className="d-flex align-items-center">
      <div className="flex-shrink-0 d-block d-lg-none me-2">
        <Link
          to="#"
          onClick={clearSelectedChat}
          className="user-chat-remove text-muted font-size-24 p-2"
        >
          <i className="bx bx-chevron-left align-middle"></i>
        </Link>
      </div>
      <div className="flex-grow-1 overflow-hidden">
        <div className="d-flex align-items-center">
          <div
            className={classnames(
              "flex-shrink-0",
              "chat-user-img",
              "align-self-center",
              "me-3",
              "ms-0",
              { online: isOnline }
            )}
          >
            {safeUser.profileImage ? (
              <>
                <img
                  src={safeUser.profileImage}
                  className="rounded-circle avatar-sm"
                  alt=""
                />
                <span
                  className={classnames("user-status", {
                    "bg-success": isOnline === STATUS_TYPES.ACTIVE,
                    "bg-warning": safeUser.status === STATUS_TYPES.AWAY,
                    "bg-danger": safeUser.status === STATUS_TYPES.DO_NOT_DISTURB,
                  })}
                ></span>
              </>
            ) : (
              <div className="avatar-sm align-self-center">
                <span
                  className={classnames(
                    "avatar-title",
                    "rounded-circle",
                    "text-uppercase",
                    "text-white",
                    colors[color]
                  )}
                >
                  <span className="username">{shortName}</span>
                </span>
              </div>
            )}
          </div>
          <div className="flex-grow-1 overflow-hidden">
            <h6 className="text-truncate mb-0 font-size-18">
              <Link
                to="#"
                onClick={onOpenUserDetails}
                className="user-profile-show text-reset"
              >
                {fullName}
              </Link>
            </h6>
            <p className="text-truncate text-muted mb-0">
              {isChannel ? (
                <small>{members} Membros</small>
              ) : (
                <small>{isOnline || ""}</small>
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const Search = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen(!dropdownOpen);

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle color="none" className="btn nav-btn dropdown-toggle" type="button">
        <i className="bx bx-search"></i>
      </DropdownToggle>
      <DropdownMenu className="dropdown-menu p-0 dropdown-menu-end dropdown-menu-lg">
        <div className="search-box p-2">
          <Input type="text" className="form-control" placeholder="Procurar.." />
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

const More = ({
  onOpenAudio,
  onOpenVideo,
  onDelete,
  isArchive,
  onToggleArchive,
}: MoreProps) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen(!dropdownOpen);

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle color="none" className="btn nav-btn" type="button">
        <i className="bx bx-dots-vertical-rounded"></i>
      </DropdownToggle>
      <DropdownMenu className="dropdown-menu-end">
        <DropdownItem
          className="d-flex justify-content-between align-items-center d-lg-none user-profile-show"
          onClick={() => alert('OK')}
        >
          Ver perfil <i className="bx bx-user text-muted"></i>
        </DropdownItem>
        <DropdownItem
          className="d-flex justify-content-between align-items-center d-lg-none"
          onClick={onOpenAudio}
        >
          Audio <i className="bx bxs-phone-call text-muted"></i>
        </DropdownItem>
        <DropdownItem
          className="d-flex justify-content-between align-items-center d-lg-none"
          onClick={onOpenVideo}
        >
          Video <i className="bx bx-video text-muted"></i>
        </DropdownItem>
        <DropdownItem
          className="d-flex justify-content-between align-items-center"
          onClick={onToggleArchive}
        >
          {isArchive ? (
            <>
              Desarquivar <i className="bx bx-archive-out text-muted"></i>
            </>
          ) : (
            <>
              Arquivar <i className="bx bx-archive text-muted"></i>
            </>
          )}
        </DropdownItem>
        <DropdownItem>Silenciado <i className="bx bx-microphone-off text-muted"></i></DropdownItem>
        <DropdownItem onClick={onDelete}>
          Excluir <i className="bx bx-trash text-muted"></i>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

const PinnedAlert = ({ onOpenPinnedTab }: PinnedAlertProps) => {
  const [visible, setVisible] = useState(true);
  const onDismiss = () => setVisible(false);

  return (
    <Alert
      fade timeout={150}
      color="warning"
      isOpen={visible}
      toggle={onDismiss}
      className="topbar-bookmark p-1 px-3 px-lg-4 pe-lg-5 pe-5 alert-dismiss-custom"
    >
      <div className="d-flex align-items-start bookmark-tabs">
        <div className="tab-list-link">
          <Link to="#" className="tab-links" onClick={onOpenPinnedTab}>
            <i className="ri-pushpin-fill align-middle me-1"></i> 10 Fixados
          </Link>
        </div>
        <div id="add-bookmark">
          <Link to="#" className="tab-links border-0 px-3">
            <i className="ri-add-fill align-middle"></i>
          </Link>
        </div>
        <UncontrolledTooltip target="add-bookmark" placement="bottom"
          transition={{ timeout: 1 }}
          delay={0}
        >
          Adicionar aos favoritos
        </UncontrolledTooltip>
      </div>
    </Alert>
  );
};

const UserHead = ({
  chatUserDetails,
  pinnedTabs,
  onOpenUserDetails,
  onDelete,
  isChannel,
  onToggleArchive,
}: UserHeadProps) => {

  const [isOpenVideoModal, setIsOpenVideoModal] = useState(false);
  const [isOpenAudioModal, setIsOpenAudioModal] = useState(false);
  const [isOpenPinnedTabModal, setIsOpenPinnedTabModal] = useState(false);

  const onOpenVideo = () => setIsOpenVideoModal(true);
  const onCloseVideo = () => setIsOpenVideoModal(false);
  const onOpenAudio = () => setIsOpenAudioModal(true);
  const onCloseAudio = () => setIsOpenAudioModal(false);
  const onOpenPinnedTab = () => setIsOpenPinnedTabModal(true);
  const onClosePinnedTab = () => setIsOpenPinnedTabModal(false);

  const { clearSelectedChat } = useChat();

  // ✅ Proteção contra undefined
  const isArchived = !!chatUserDetails?.isArchived;

  return (
    <div className="p-3 p-lg-4 user-chat-topbar">
      <Row className="align-items-center">
        <Col sm={4} className="col-8">
          <ProfileImage
            chatUserDetails={chatUserDetails}
            onCloseConversation={clearSelectedChat}
            onOpenUserDetails={onOpenUserDetails}
            isChannel={isChannel}
          />
        </Col>
        <Col sm={8} className="col-4">
          <ul className="list-inline user-chat-nav text-end mb-0">
            <li className="list-inline-item">
              <Search />
            </li>

            {!isChannel && (
              <>
                <li className="list-inline-item d-none d-lg-inline-block me-2 ms-0">
                  <Button
                    type="button"
                    color="none"
                    className="btn nav-btn"
                    onClick={onOpenAudio}
                  >
                    <i className="bx bxs-phone-call"></i>
                  </Button>
                </li>
                <li className="list-inline-item d-none d-lg-inline-block me-2 ms-0">
                  <Button
                    type="button"
                    color="none"
                    className="btn nav-btn"
                    onClick={onOpenVideo}
                  >
                    <i className="bx bx-video"></i>
                  </Button>
                </li>
              </>
            )}

            <li className="list-inline-item d-none d-lg-inline-block me-2 ms-0">
              <button
                onClick={onOpenUserDetails}
                type="button"
                className="btn nav-btn user-profile-show"
              >
                <i className="bx bxs-info-circle"></i>
              </button>
            </li>

            {/* ✅ restaurado com fallback seguro */}
            <li className="list-inline-item d-none d-lg-inline-block me-2 ms-0">
              <More
                onOpenAudio={onOpenAudio}
                onOpenVideo={onOpenVideo}
                onDelete={onDelete}
                isArchive={isArchived}
                onToggleArchive={onToggleArchive}
              />
            </li>
          </ul>
        </Col>
      </Row>

      <PinnedAlert onOpenPinnedTab={onOpenPinnedTab} />

      {isOpenAudioModal && (
        <AudioCallModal isOpen={isOpenAudioModal} onClose={onCloseAudio} user={chatUserDetails} />
      )}
      {isOpenVideoModal && (
        <VideoCallModal isOpen={isOpenVideoModal} onClose={onCloseVideo} user={chatUserDetails} />
      )}
      {isOpenPinnedTabModal && (
        <AddPinnedTabModal
          isOpen={isOpenPinnedTabModal}
          onClose={onClosePinnedTab}
          pinnedTabs={pinnedTabs}
        />
      )}
    </div>
  );
};

export default UserHead;
